export default "__VITE_ASSET__DzSbEavZ__"